export const sequentialKeyGenerator = () => {
    let key = 0;

    return () => {
        key += 1;
        return key;
    }
}